// Suspense fallback for lazy-loaded routes. Moved from `src/app/` to
// `src/shared/ui/` as part of plan 24's primitives barrel.
//
// Intentionally lightweight: a centred, reduced-motion-friendly spinner
// over the normal `bg-stone-50` background, sized to fill the viewport
// minus the navbar. We avoid motion/react here so the fallback can render
// while the motion chunk is still being fetched.

import { Spinner } from './Spinner';

export const PageFallback = () => (
  <div
    className="min-h-[60vh] flex items-center justify-center"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div className="flex flex-col items-center gap-4 text-stone-500">
      <Spinner size="lg" label="Loading page" className="text-stone-900" />
    </div>
  </div>
);
